module.exports = __webpack_public_path__ + "img/imagen2.a63be213.png";